module.exports = {"513232100":"达扎寺镇","513232101":"唐克镇","513232102":"红星镇","513232103":"辖曼镇","513232200":"班佑乡","513232201":"阿西乡","513232205":"麦溪乡","513232206":"嫩哇乡","513232207":"冻列乡","513232208":"崇尔乡","513232209":"热尔乡","513232210":"占哇乡","513232211":"降扎乡","513232212":"巴西乡","513232213":"阿西茸乡","513232214":"求吉乡","513232215":"包座乡","513232400":"白河牧场","513232401":"辖曼牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513232.json
// module id = 2224
// module chunks = 0